import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import AddKaptionAccessToken from './AddKaptionAccessToken.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/kaption-access-tokens'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_kaption_access_tokens',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'new',
          name: 'settings_kaption_access_tokens_new',
          component: AddKaptionAccessToken,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
